import paginate from 'utils/paginate'

// Generate debit note data
const debitNoteData = []
const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']

const cabangNames = [
    { nama_wilayah: 'Bank Sejahtera Pusat', nama_cabang_pusat: 'Bank Sejahtera Cab. Jakarta Selatan' },
    { nama_wilayah: 'Bank Sejahtera Pusat', nama_cabang_pusat: 'Bank Sejahtera Cab. Bandung' },
    { nama_wilayah: 'Bank Sejahtera Pusat', nama_cabang_pusat: 'Bank Sejahtera Cab. Surabaya' },
    { nama_wilayah: 'Bank Makmur Pusat', nama_cabang_pusat: 'Bank Makmur Cab. Jakarta Barat' },
    { nama_wilayah: 'Bank Makmur Pusat', nama_cabang_pusat: 'Bank Makmur Cab. Semarang' },
    { nama_wilayah: 'Bank Mandala Pusat', nama_cabang_pusat: 'Bank Mandala Cab. Medan' },
    { nama_wilayah: 'Bank Mandala Pusat', nama_cabang_pusat: 'Bank Mandala Cab. Makassar' },
]

for (let i = 0; i < 15; i++) {
    const cab = cabangNames[i % cabangNames.length]
    const month = (i % 12) + 1
    const activeCount = 3 + (i % 5)
    const canceledCount = i % 3
    const premium = (activeCount * 17500000)

    debitNoteData.push({
        id: i + 1,
        uuid: `dn-${String(i + 1).padStart(4, '0')}`,
        year: 2024 + Math.floor(i / 12),
        month,
        nama_wilayah: cab.nama_wilayah,
        nama_cabang_pusat: cab.nama_cabang_pusat,
        policy_status_active: activeCount,
        policy_status_canceled: canceledCount,
        premium_amount: premium,
        outstanding_amount: i % 3 === 0 ? premium : 0,
        status_payment_insurance: i % 3 === 0 ? 'outstanding' : 'paid',
        status_payment_bank: i % 4 === 0 ? 'outstanding' : 'paid',
        no_invoice: `INV-DN-${2024}-${String(i + 1).padStart(4, '0')}`,
    })
}

// Credit note data
const brokerageFeeData = []
for (let i = 0; i < 10; i++) {
    const totalBrokerage = 5000000 + (i * 2500000)
    const ppnRate = 11
    const pphRate = 2
    const totalPpn = Math.round(totalBrokerage * ppnRate / 100)
    const totalPph = Math.round(totalBrokerage * pphRate / 100)

    brokerageFeeData.push({
        id: i + 1,
        uuid: `bf-${String(i + 1).padStart(4, '0')}`,
        no_invoice: `INV-BF-${2024}-${String(i + 1).padStart(4, '0')}`,
        tanggal_polis_aktif: `2024-${String((i % 12) + 1).padStart(2, '0')}-01`,
        brokerage_rate: 5,
        gross_total_brokerage_fee: totalBrokerage,
        total_polis_terbit: 3 + (i % 5),
        ppn: ppnRate,
        total_ppn: totalPpn,
        pph: pphRate,
        total_pph: totalPph,
        net_total_brokerage_fee_amount: totalBrokerage + totalPpn - totalPph,
        status_payment: i % 3 === 0 ? 'outstanding' : 'paid',
        interest_insured: false,
    })
}

const bankFeeData = []
for (let i = 0; i < 8; i++) {
    bankFeeData.push({
        id: i + 1,
        uuid: `bnf-${String(i + 1).padStart(4, '0')}`,
        no_invoice: `INV-BNF-${2024}-${String(i + 1).padStart(4, '0')}`,
        tanggal_polis_aktif: `2024-${String((i % 12) + 1).padStart(2, '0')}-01`,
        bank_fee_rate: 3,
        total_bank_fee: 3000000 + (i * 1500000),
        total_polis: 4 + (i % 4),
        status_payment: i % 3 === 0 ? 'outstanding' : 'paid',
    })
}

const refundPremiListData = []
for (let i = 0; i < 6; i++) {
    refundPremiListData.push({
        id: i + 1,
        uuid: `rp-${String(i + 1).padStart(4, '0')}`,
        no_invoice: `INV-RP-${2024}-${String(i + 1).padStart(4, '0')}`,
        nama_nasabah: ['Budi Santoso', 'Siti Rahayu', 'Ahmad Hidayat', 'Dewi Lestari', 'Eko Prasetyo', 'Fitri Handayani'][i],
        policy_number: `POL-2024-${String(i + 1).padStart(6, '0')}`,
        total_refund: 2000000 + (i * 1000000),
        status_payment: i % 2 === 0 ? 'outstanding' : 'paid',
    })
}

export default function financeFakeApi(server, apiPrefix) {

    // === Debit Notes ===

    server.get(`${apiPrefix}/finance/debitnote/list`, (schema, request) => {
        return { data: { data: debitNoteData, total: debitNoteData.length } }
    })

    server.get(`${apiPrefix}/finance/debitnote`, (schema, request) => {
        return { data: { data: debitNoteData, total: debitNoteData.length } }
    })

    server.get(`${apiPrefix}/finance/debitnote/:id`, (schema, request) => {
        const id = parseInt(request.params.id)
        const note = debitNoteData.find(d => d.id === id)
        return { data: { data: note || null } }
    })

    server.post(`${apiPrefix}/finance/debitnote/update-debit-note-invoice/by-no-invoice`, () => {
        return { data: { message: 'Invoice berhasil diperbarui' } }
    })

    server.get(`${apiPrefix}/finance/debitnote/get-by-nb/:id`, (schema, request) => {
        return { data: { data: null } }
    })

    server.get(`${apiPrefix}/finance/debitnote/insured-invoice`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/debitnote/reportingfinance/debitnote`, () => {
        return { data: { data: debitNoteData } }
    })

    server.post(`${apiPrefix}/finance/debitnote/upload-payment-slip/:id`, () => {
        return { data: { message: 'Bukti pembayaran berhasil diunggah' } }
    })

    server.get(`${apiPrefix}/finance/debitnote/download-payment-slip/:id`, () => {
        return new ArrayBuffer(0)
    })

    server.post(`${apiPrefix}/finance/debitnote/preview-payment-slip/:uuid`, () => {
        return { data: { data: null } }
    })

    server.get(`${apiPrefix}/finance/debitnote/get-data-ib/:id`, () => {
        return { data: { data: null } }
    })

    server.post(`${apiPrefix}/finance/debitnote/payment-history`, () => {
        return { data: { data: [] } }
    })

    // === Credit Notes ===

    // Overriding Commission
    server.post(`${apiPrefix}/finance/overriding-commission/list`, () => {
        return { data: { data: [], total: 0 } }
    })

    server.post(`${apiPrefix}/finance/overriding-commission/detail`, () => {
        return { data: { data: null } }
    })

    server.post(`${apiPrefix}/finance/overriding-commission/insured`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/overriding-commission/no_invoice`, () => {
        return { data: { data: [] } }
    })

    server.put(`${apiPrefix}/finance/overriding-commission/update-payment/system`, () => {
        return { data: { message: 'Pembayaran berhasil diperbarui' } }
    })

    // Brokerage Fee
    server.post(`${apiPrefix}/finance/creditnotebroker/get-list`, (schema, { requestBody }) => {
        const body = JSON.parse(requestBody)
        const page = body.page || 1
        const limit = body.limit || 10
        const paginatedData = paginate(brokerageFeeData, limit, page)
        return { data: { data: paginatedData, total: brokerageFeeData.length } }
    })

    server.post(`${apiPrefix}/finance/creditnotebroker/get-list-detail`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/creditnotebroker/get-list-insured`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/creditnotebroker/get-list-invoicenumber`, () => {
        return { data: { data: brokerageFeeData } }
    })

    server.post(`${apiPrefix}/finance/creditnotebroker/update-invoice-system`, () => {
        return { data: { message: 'Invoice berhasil diperbarui' } }
    })

    server.post(`${apiPrefix}/finance/creditnotebroker/update-invoice-excel`, () => {
        return { data: { message: 'Invoice berhasil diperbarui' } }
    })

    // Bank Fee
    server.post(`${apiPrefix}/finance/creditnotebank/get-list`, (schema, { requestBody }) => {
        const body = JSON.parse(requestBody)
        const page = body.page || 1
        const limit = body.limit || 10
        const paginatedData = paginate(bankFeeData, limit, page)
        return { data: { data: paginatedData, total: bankFeeData.length } }
    })

    server.post(`${apiPrefix}/finance/creditnotebank/get-detail`, () => {
        return { data: { data: null } }
    })

    server.post(`${apiPrefix}/finance/creditnotebank/get-insured`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/creditnotebank/get-by-no-inv`, () => {
        return { data: { data: bankFeeData } }
    })

    server.put(`${apiPrefix}/finance/creditnotebank/update-payment`, () => {
        return { data: { message: 'Pembayaran berhasil diperbarui' } }
    })

    server.put(`${apiPrefix}/finance/creditnotebank/update-payment-excel/:id`, () => {
        return { data: { message: 'Pembayaran berhasil diperbarui' } }
    })

    // Refund Premi
    server.post(`${apiPrefix}/finance/creditnoterefund/getlist`, (schema, { requestBody }) => {
        const body = JSON.parse(requestBody)
        const page = body.page || 1
        const limit = body.limit || 10
        const paginatedData = paginate(refundPremiListData, limit, page)
        return { data: { data: paginatedData, total: refundPremiListData.length } }
    })

    server.post(`${apiPrefix}/finance/creditnoterefund/getdetail`, () => {
        return { data: { data: null } }
    })

    server.post(`${apiPrefix}/finance/creditnoterefund/getlistinsured`, () => {
        return { data: { data: [] } }
    })

    server.post(`${apiPrefix}/finance/creditnoterefund/getdetailbyinvoice`, () => {
        return { data: { data: refundPremiListData } }
    })

    server.post(`${apiPrefix}/finance/creditnoterefund/updatebysystem`, () => {
        return { data: { message: 'Pembayaran berhasil diperbarui' } }
    })

    // Reports
    server.post(`${apiPrefix}/finance/reportingfinance/brokercreditnote`, () => {
        return { data: { data: brokerageFeeData } }
    })

    server.post(`${apiPrefix}/finance/reportingfinance/creditnoterefund`, () => {
        return { data: { data: refundPremiListData } }
    })

    server.post(`${apiPrefix}/finance/reportingfinance/bankcreditnote`, () => {
        return { data: { data: bankFeeData } }
    })

    // === Billing ===

    server.get(`${apiPrefix}/finance/billing`, () => {
        return { data: { data: [], total: 0 } }
    })

    server.get(`${apiPrefix}/finance/billing/detail/:billingId`, () => {
        return { data: { data: null } }
    })

    server.post(`${apiPrefix}/finance/dashboard-billing/billing`, () => {
        return { data: { data: [] } }
    })

    server.get(`${apiPrefix}/finance/billing/overview-detail/:id`, () => {
        return { data: { data: null } }
    })

    server.put(`${apiPrefix}/finance/billing/update/:billingId`, () => {
        return { data: { message: 'Billing berhasil diperbarui' } }
    })

    server.post(`${apiPrefix}/configurations/billing/store`, () => {
        return { data: { message: 'Konfigurasi billing berhasil disimpan' } }
    })
}
